import { map, filter } from 'lodash';
import { createSlice } from '@reduxjs/toolkit';
// utils
import { axiosInstance as axios } from '../../utils/axios';
//
import { dispatch } from '../store';

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: false,
  data: [],
  meta: null,
  params: {
    page: 1,
    active: true,
    deleted: false,
  },
  record: null,
};

const slice = createSlice({
  name: 'accounts',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET accounts
    getAccountsSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.meta = action.payload.meta;
      state.error = false;
    },

    // GET account
    getAccountSuccess(state, action) {
      state.isLoading = false;
      state.record = action.payload;
      state.error = false;
    },

    // CREATE account
    createAccountSuccess(state, action) {
      const record = action.payload;
      state.isLoading = false;
      state.data = [...state.data, record];
      state.error = false;
    },

    // UPDATE account
    updateAccountSuccess(state, action) {
      state.record = action.payload;
      const updateRecord = map(state.data, (_record) => {
        if (_record.id === state.record.id) {
          return state.record;
        }
        return _record;
      });

      state.isLoading = false;
      state.data = updateRecord;
      state.params = { ...state.params };
      state.error = false;
    },

    // DELETE account
    deleteAccountSuccess(state, action) {
      const { id } = action.payload;
      const deleteRecord = filter(state.data, (user) => user.id !== id);
      state.isLoading = false;
      state.data = deleteRecord;
      state.error = false;
    },

    // SET PARAMS
    setParams(state, action) {
      state.params = action.payload;
    },

    // REFRESH PARAMS
    refreshParams(state) {
      state.params = { ...state.params };
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { setParams, refreshParams } = slice.actions;

// ----------------------------------------------------------------------

export function getAccounts(params = {}) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/accounts/', {
        params,
      });
      dispatch(slice.actions.getAccountsSuccess(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      return error;
    }
  };
}

// ----------------------------------------------------------------------

export function getAccount(id) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/accounts/${id}/`);
      dispatch(slice.actions.getAccountSuccess(response.data));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function createAccount(record) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/accounts/', record);
      dispatch(slice.actions.createAccountSuccess(response.data));
      return response.data;
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

// ----------------------------------------------------------------------

export function updateAccount(id, record) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.put(`/accounts/${id}/`, record);
      dispatch(slice.actions.updateAccountSuccess(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

export function partialUpdateAccount(id, record) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.patch(`/accounts/${id}/`, record);
      dispatch(slice.actions.updateAccountSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

// ----------------------------------------------------------------------

export function deleteAccount(id) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      await axios.delete(`/accounts/${id}/`);
      dispatch(slice.actions.deleteAccountSuccess({ id }));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

// ----------------------------------------------------------------------

export function actionAccount(id, data) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post(`/accounts/${id}/action/`, data);
      dispatch(slice.actions.updateAccountSuccess(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

// ----------------------------------------------------------------------

export function actionHistoryAccount(id, data) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post(`/accounts/${id}/history/`, data);
      dispatch(slice.actions.updateAccountSuccess(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}
